import Vue, { PropType } from 'vue';
import promotionElement, { PromotionStyle } from '../Products/Promotion';
import { SmartSuggestV4 } from '../../../../declarations/request';

export default Vue.component('smart-suggest-promotion', {
    template: `
    <smart-suggest-block
        v-if="shouldContainPromotion && config.blocks.promotion && promotion"
        class="fl-as-promotion"
        :icon="assets.iconPromotion"
        :name="config.blocks.promotion"
    >
      <fl-promotion :promotion="promotion" />
    </smart-suggest-block>
  `,
    inject: ['config', 'assets', 'HandleInteractionService'],
    props: {
        promotion: Object as PropType<SmartSuggestV4.Promotion>,
    },
    components: {
        Promotion: promotionElement,
    },
    computed: {
        shouldContainPromotion(): boolean {
            return this.config.assistedSuggest.config.promotionStyle === PromotionStyle.IN_SIDEBAR;
        },
    },
});
